import React, { lazy, useRef, Suspense,useState,useEffect } from "react";
import { Image } from "react-bootstrap";
import "./App.css";
import { Rates } from "rate-quotes";
import "./css/Rates.css";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
import "./css/ContactUs.css";
import { Element } from "react-scroll";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import ReactGA from "react-ga";
import Header from "./modules/HeaderNew";
import { CookieSetting } from "cookiesetting-component";
const Footer = lazy(() => import("./modules/CommenFooterComponent/index"));
const Banner = lazy(() => import("./modules/BannerNew"));
const BannerInfo = lazy(() => import("./modules/BannerInfoNew"));
const InfoSection = lazy(() => import("./modules/InfoSection"));
const Gallery = lazy(() => import("./modules/GalleryNew"));
const LoanCalculator = lazy(() => import("./modules/LoanCalculator"));

const trackingId = "UA-168595630-1";
ReactGA.initialize(trackingId);

function App() {
  // ATH-14: ref used to target first input field of blgt
  // this is passed to the banner so that we can trigger a smooth scroll on click.
  const contactRef = useRef(null);
  const imgCDNUrl = process.env.REACT_APP_CDN_URL;
  const isProduction = process.env.NODE_ENV === "production"
  const [showOtherComponents, setShowOtherComponents] = useState(false);
 useEffect(() => {
   const handleScroll = () => {
     const windowHeight = window.innerHeight;
     const documentHeight = document.body.offsetHeight;
     const scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
     const maxScroll = documentHeight - windowHeight;
     const percentage = (scrollPosition / maxScroll) * 100;


     if (percentage > 50) {
       setShowOtherComponents(true);
     }
   };


   window.addEventListener('scroll', handleScroll);
   return () => {
     window.removeEventListener('scroll', handleScroll);
   };
 }, []);

  return (
    <CacheBuster
    currentVersion={appversion.version}
    isEnabled={isProduction} //If false, the library is disabled.
    isVerboseMode={false} //If true, the library writes verbose logs to console.
    metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
  >
    <div className="App taca_app">
      <Header />
      <Suspense fallback= {<div />}>
        <Banner ref={contactRef} />
      </Suspense>
      <Suspense fallback= {<div />}>
        <Element name="about_us"></Element>
        <BannerInfo />
      </Suspense>
      <Suspense fallback= {<div />}>
        <Element name="rates"></Element>
        <div id="rates_section_all">
          <Rates
            leadSource="INBOUNDNONPC"
            promoCode="ATH"
            phoneText="1-(844)786-9378"
            phoneNumber="tel:+18447869378"
            offertext="$750 Lender Credit"
            Domain = "ny.swmc.com"
          />
        </div>
      </Suspense>
      <Suspense fallback= {<div />}>
        <Element name="info"></Element>
        <InfoSection />
      </Suspense>
      <Suspense fallback= {<div />}>
        <Element name="calc"></Element>
        <LoanCalculator />
      </Suspense>
      <Suspense fallback= {<div />}>
        <Element name="contact"></Element>
        <div id="contact-wrapper">
          <BorrowerLeadGenerationTool
            phoneNumber="tel:+18447869378"
            leadSource="AUTISMHEROES"
            phoneText="(844)786-9378"
            supportEmailId="lead.management@swmc.com"
            ref={contactRef}
            statesDomain={process.env.REACT_APP_STATE_DOMAIN}
          />
          <div id="contact-img-wrapper">
            <Image fluid src={imgCDNUrl + "contact_us_new/contact_img.png"} alt="Contact" />
          </div>
        </div>
      </Suspense>
      <Suspense fallback= {<div />}>
        <Element name="gallery"></Element>
        <Gallery />
      </Suspense>
      <Suspense fallback= {<div />}>
        <Footer />
      </Suspense>
      <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
          />
    </div>
    </CacheBuster>
  );
}

export default App;
